/* eslint-disable jira/filename-case */
import React from 'react';
import { AuthenticationCheck } from '@jira/spa-apps__common/src/AuthenticationCheck.tsx';
import { SpaStatePageReady } from '@atlassian/jira-spa-state-controller/src/components/main.tsx';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';
import { withRouter, type RouteContext } from '@atlassian/react-resource-router';
import RouteWrapperEditPage from './EditAdministrationEdit.tsx';

type Props = RouteContext;

const EditPage = (props: Props) => (
	<UFOSegment name="applinks-administration-edit-page">
		<AuthenticationCheck>
			<RouteWrapperEditPage id={props.match.params.applinkId ?? null} {...props} />
			<SpaStatePageReady />
		</AuthenticationCheck>
	</UFOSegment>
);

const Edit: {
	(props: Props): React.JSX.Element;
	displayName: string;
} = withRouter(EditPage);

export default Edit;
